import { fetchRequest } from '@growth/fetch-request';
import { prod, endpoints } from '@growth/api-configs';
import { getVisitorIdBrowser } from '@growth/visitor-id/browser';
import { getConfigValueFromEnv } from '@growth/api-configs-webpack-plugin/helpers';
import { g as generatePokusBodyRequest, _ as _extends } from './pokus-c8bb5eb2.esm.js';
import { getAuthToken, isUserTokenPresent } from '@growth/auth-utils';

var fetchAppOpenUrl = function fetchAppOpenUrl(opts) {
  var appBannerUrl = getConfigValueFromEnv('appBannerUrl') || prod.appBannerUrl;
  var apiPayload = (opts == null ? void 0 : opts.apiPayload) || {};
  var vid = getVisitorIdBrowser();
  var data = {};
  if (apiPayload != null && apiPayload.tagid) data.tagid = apiPayload.tagid;
  if (apiPayload != null && apiPayload.godata) data.godata = apiPayload.godata;
  if (apiPayload != null && apiPayload.campaign) data.campaign = apiPayload.campaign;
  if (apiPayload != null && apiPayload.loginReq) data.login_req = apiPayload.loginReq;
  if (apiPayload != null && apiPayload.mweb2app_filo) data.mweb2app_filo = apiPayload.mweb2app_filo;
  if (vid) data.web_vid = vid;
  var payload = {
    /*
       * keep the timeout small for this api,
       */
    timeout: 1500
  }; // TODO: create a helper function to normalize the request payload object
  //       normalize should remove falsy value and empty object

  try {
    if (Object.keys(data).length > 0) {
      payload.body = data;
    }
  } catch (e) {
    throw new Error("linkDetails prop is not a correct json- failed to stringify error: " + e);
  }

  return fetchRequest("" + appBannerUrl + endpoints.appBannerUrl, payload).post();
};

var fetchPokusClientData = function fetchPokusClientData(pokusOptions, extraHeaders) {
  if (extraHeaders === void 0) {
    extraHeaders = {};
  }

  var deviceId = pokusOptions.deviceId || getVisitorIdBrowser() || '';
  var lobName = pokusOptions.lob || 'COMMON';

  var _generatePokusBodyReq = generatePokusBodyRequest({
    isMobile: pokusOptions.isMobile,
    lob: lobName,
    deviceId: deviceId,
    extraOptions: pokusOptions
  }),
      request = _generatePokusBodyReq.request;

  var pokusUrl = getConfigValueFromEnv('pokusUrl') || prod.pokusUrl;
  var authToken = pokusOptions.authToken || getAuthToken();
  var headers = {};
  if (authToken) headers['oauth-goibibo'] = authToken;
  return fetchRequest("" + pokusUrl + endpoints.pokusUrl, {
    body: request,
    credentials: 'omit',
    headers: _extends({}, headers, extraHeaders)
  }).post().then(function (res) {
    var _res$perLobMap;

    return (_res$perLobMap = res.perLobMap) == null ? void 0 : _res$perLobMap[lobName].metadataValues;
  });
};

var fetchUserDetails = function fetchUserDetails(_ref) {
  var timeout = _ref.timeout;
  var host = getConfigValueFromEnv('goibibo') || prod.goibibo;
  return fetchRequest("" + host + endpoints.userWidget, {
    timeout: timeout
  }).post();
};

var fetchRecommendEarnDetails = function fetchRecommendEarnDetails(details) {
  var recommendEarnUrl = getConfigValueFromEnv('recommendEarnUrl') || prod.recommendEarnUrl;
  var token = getAuthToken();
  var headers = {
    auth: token,
    os: details == null ? void 0 : details.flavour
  };
  return fetchRequest("" + recommendEarnUrl + endpoints.recommendEarnUrl, {
    headers: headers,
    body: {
      hotelId: details.hotelId,
      source: details.source
    },
    credentials: 'omit'
  }).post();
};

var generateSkywalkerBodyRequest = function generateSkywalkerBodyRequest(_ref) {
  var extraReqBody = _ref.extraReqBody;

  var request = _extends({
    brand: 'gi',
    user: {
      loginChannel: 'GI'
    }
  }, extraReqBody);

  return request;
};

var fetchSkywalkerClientData = function fetchSkywalkerClientData(skywalkerOptions, extraHeaders) {
  if (extraHeaders === void 0) {
    extraHeaders = {};
  }

  var endpointPath = skywalkerOptions.endpointPath,
      extraReqBody = skywalkerOptions.extraReqBody;
  var request = generateSkywalkerBodyRequest({
    extraReqBody: extraReqBody
  });
  var skywalkerUrl = getConfigValueFromEnv('skywalkerUrl') || prod.skywalkerUrl;
  var headers = {
    brand: 'gi',
    deviceid: String
  };

  if (isUserTokenPresent()) {
    headers.auth = getAuthToken();
  }

  var dvid = getVisitorIdBrowser();

  if (dvid) {
    headers.deviceid = dvid;
  }

  return fetchRequest("" + skywalkerUrl + endpoints.skywalkerV1 + endpointPath, {
    body: request,
    credentials: 'omit',
    query: 'language=eng&currency=inr&region=in&brand=GI',
    headers: _extends({}, headers, extraHeaders)
  }).post();
};

var fetchAutoSuggetDailyStealDeal = function fetchAutoSuggetDailyStealDeal(userLocation) {
  var dsdVoyagerUrl = getConfigValueFromEnv('dsdVoyager') || prod.dsdVoyager;
  var userSelectedLocation = userLocation.userVal;
  return fetchRequest("" + dsdVoyagerUrl + endpoints.dsdVoyager, {
    credentials: 'omit',
    query: "search_query=" + userSelectedLocation + "&limit=10&include_t=[\"voy.city\"]"
  }).post();
};

var fetchPushRecentSearch = function fetchPushRecentSearch(searchCollection) {
  var url = getConfigValueFromEnv('recentSearchPush') || prod.recentSearchPush;
  var token = getAuthToken();
  var deviceid = getVisitorIdBrowser();
  var headers = {
    'Content-Type': 'application/json',
    'Request-Data-Encoding': 'json'
  };
  if (token) headers['oauth-goibibo'] = token;
  if (deviceid) headers.deviceid = deviceid;
  return fetchRequest("" + url + endpoints.recentSearchPush, {
    headers: headers,
    body: JSON.stringify(searchCollection),
    credentials: 'omit'
  }).post();
};

var fetchAppContext = function fetchAppContext(link) {
  var url = getConfigValueFromEnv('voyager') || prod.voyager;
  var raw = "url=" + (link || '');
  return fetchRequest("" + url + endpoints.appContext, {
    body: raw,
    credentials: 'omit'
  }).post();
};

export { fetchAppContext, fetchAppOpenUrl, fetchAutoSuggetDailyStealDeal, fetchPokusClientData, fetchPushRecentSearch, fetchRecommendEarnDetails, fetchSkywalkerClientData, fetchUserDetails };
